import React, { useEffect, useRef, useState } from "react";
import { PageContainer, QnaFormContainer } from "./component/styled/notice";
import PageInfo from "./component/common/pageInfo";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import ImageUploadAdapterPlugin from "../../utils/ImageUploadAdapter";

import { useModal } from "../../hooks/useModal";
import useUploadFiles from "../../hooks/useUploadFiles";

const HelpWritePage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const user = useSelector((state) => state?.user?.data[0]);

  const ckeditorInstanceRef = useRef(null);
  const [formData, setFormData] = useState({ title: "", content: "" });

  const { modal, openModal, closeModal } = useModal();
  const { uploadEmbedded } = useUploadFiles();

  useEffect(() => {
    if (!user) {
      toast.error("로그인 후 이용 가능합니다.", { toastId: "no-access" });
      navigate("/login");
    }
    const inquiry = location?.state?.inquiry;
    if (inquiry) {
      setFormData({ ...inquiry });
    }
  }, []);

  const handleEditorChange = (_, editor) => {
    const newContent = editor.getData();
    setFormData((data) => ({ ...data, content: newContent }));
  };

  const changeInput = (e) => {
    const { name, value } = e.target;
    setFormData((data) => ({ ...data, [name]: value }));
  };

  const submitInquiry = async () => {
    try {
      const content = await uploadEmbedded(formData.content);

      const url = `/erp/inquiry/${formData.id ? "update" : "create"}`;
      const body = {
        ...formData,
        content: content,
        mberNo: user.mberNo,
        cmpnyNo: 35719,
      };

      const res = await axios.post(url, body);
      if (res.status === 200) {
        toast.success(`문의가 ${formData.id ? "수정" : "작성"}되었습니다.`);
        navigate("/help");
      }
    } catch (error) {
      console.error("문의 등록 실패:", error);
      toast.error("문의 처리 중 오류가 발생했습니다.");
    } finally {
      closeModal();
    }
  };

  // 버튼 클릭 시
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.title || !formData.content) {
      toast.error("제목과 내용을 적어주세요.");
      return;
    }

    openModal({
      isOpen: true,
      type: "confirmation",
      title: `${formData?.id ? "문의 수정" : "문의 작성"}`,
      message: [`문의를 ${formData?.id ? "수정" : "작성"}하시겠습니까?`],
      handleConfirm: () => submitInquiry(),
      handleCancel: () => closeModal(),
    });
  };

  return (
    <PageContainer>
      {modal}
      <PageInfo title="1:1 문의" content={"서비스 사용 중 궁금한 점이나 문제를 해결해드립니다."} />
      <QnaFormContainer onSubmit={handleSubmit}>
        <div className="title">
          <div className="tit">문의제목</div>
          <div className="cont">
            <input
              type="text"
              placeholder="문의제목을 작성해주세요."
              onChange={changeInput}
              name="title"
              value={formData.title}
            />
          </div>
        </div>
        <div className="content">
          <div className="tit">문의내용</div>
          <div className="cont">
            <CKEditor
              editor={ClassicEditor}
              data={formData.content}
              onChange={handleEditorChange}
              config={{
                extraPlugins: [ImageUploadAdapterPlugin],
                toolbar: ["bold", "italic", "imageUpload"],
              }}
              ref={ckeditorInstanceRef}
            />
          </div>
        </div>
        <div className="action">
          <button type="button" onClick={() => navigate("/help")}>
            취소
          </button>
          <button type="submit">{formData?.id ? "수정" : "문의"}하기</button>
        </div>
      </QnaFormContainer>
    </PageContainer>
  );
};

export default HelpWritePage;
